import * as angular from 'angular';
import { IRequestService } from '../request.service';
import { ObjectAccessRights } from '../../models';

export interface IobjectAccessRightsService {
    getAll(force?: boolean): angular.IPromise<ObjectAccessRights[]>;
    update(updated: ObjectAccessRights): angular.IPromise<ObjectAccessRights>;
}

export class ObjectAccessRightsService implements IobjectAccessRightsService {

    static serviceId = 'objectAccessRightsService';
    static $inject = ['requestService'];

    private _controllerUrl = 'objectsAccessRights';

    constructor(private _requestService: IRequestService) {
    }

    getAll(force?: boolean): angular.IPromise<ObjectAccessRights[]> {
        const url = `${this._controllerUrl}`;
        if (force) {
            this._requestService.cleanCacheAtV1(url);
        }
        return this._requestService.getAtV1(url, undefined, true);
    }

    update(updated: ObjectAccessRights): angular.IPromise<ObjectAccessRights> {
        return this._requestService.postAtV1<ObjectAccessRights>(`${this._controllerUrl}/addOrUpdate`, updated, undefined, true);
    }

}